import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    state: null,
    newState: null,
    project_id: null,
    name: "",
    standard: null,
    editedName: "",
    buildings: [],
    equipments: [],
    equipment_type: null,
    date_calibrated: null,
    date_shared: null,
    generatingPdf: false,
    maintenance: false,
    flagSubscription: null,
    users: null,
    stateSubscription: null,
    revokeAccessSubscription: null,
    available_standards: [],
    missingEquipmentUsers: [],
  },
  mutations,
  actions,
};
